// extracted by mini-css-extract-plugin
module.exports = {"changePassword":"ChangePassword_changePassword__kVEJe","marginBottom":"ChangePassword_marginBottom__MK_-u"};